import { render, staticRenderFns } from "./PosResetPassword.vue?vue&type=template&id=68260dff"
import script from "./PosResetPassword.vue?vue&type=script&lang=js"
export * from "./PosResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports